/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WorkstreamExecSponsorInboxReviewItemReview } from '../models/WorkstreamExecSponsorInboxReviewItemReview';
import type { WorkstreamExecSponsorInboxWorkstreamDetail } from '../models/WorkstreamExecSponsorInboxWorkstreamDetail';
import type { WorkstreamExecSponsorInboxWorkstreamsResponse } from '../models/WorkstreamExecSponsorInboxWorkstreamsResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExecSponsorInboxService {

    /**
     * Get Exec Sponsor Inbox Workstreams
     * @returns WorkstreamExecSponsorInboxWorkstreamsResponse Successful Response
     * @throws ApiError
     */
    public static getExecSponsorInboxWorkstreamsApiV1ExecSponsorInboxWorkstreamsGet(): CancelablePromise<WorkstreamExecSponsorInboxWorkstreamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exec-sponsor-inbox/workstreams',
        });
    }

    /**
     * Get Exec Sponsor Inbox Workstream Detail
     * @param workstreamId
     * @returns WorkstreamExecSponsorInboxWorkstreamDetail Successful Response
     * @throws ApiError
     */
    public static getExecSponsorInboxWorkstreamDetailApiV1ExecSponsorInboxWorkstreamsWorkstreamIdGet(
        workstreamId: number,
    ): CancelablePromise<WorkstreamExecSponsorInboxWorkstreamDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/exec-sponsor-inbox/workstreams/{workstream_id}',
            path: {
                'workstream_id': workstreamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Mark Exec Sponsor Inbox Review Item Reviewed
     * @param workstreamId
     * @param itemType
     * @param itemId
     * @returns WorkstreamExecSponsorInboxReviewItemReview Successful Response
     * @throws ApiError
     */
    public static markExecSponsorInboxReviewItemReviewedApiV1ExecSponsorInboxWorkstreamsWorkstreamIdReviewItemsItemTypeItemIdPut(
        workstreamId: number,
        itemType: string,
        itemId: string,
    ): CancelablePromise<WorkstreamExecSponsorInboxReviewItemReview> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/exec-sponsor-inbox/workstreams/{workstream_id}/review-items/{item_type}/{item_id}',
            path: {
                'workstream_id': workstreamId,
                'item_type': itemType,
                'item_id': itemId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
